export const cyclesSelector = state => state.cycles;
